import './list-toolbar.scss';

import { Badge, Button, Input } from 'antd';
import { useTranslation } from 'react-i18next';

import { FilterOutlined, SearchOutlined } from '@/media/antd-icons';

interface IProps {
  searchValue: string;
  searchPlaceholder: string;
  onSearchChange: (value: string) => void;
  /** Без обработчика кнопки «Все фильтры» нет — у списка только поиск. */
  onOpenFilters?: () => void;
  /** Сколько фильтров задано — счётчик на кнопке. */
  activeFiltersCount?: number;
}

/**
 * Поиск по списку и кнопка модалки фильтров, как над реестрами лизингового кабинета.
 * На узком контейнере у кнопки остаётся только иконка.
 */
const ListToolbar: React.FC<IProps> = ({
  searchValue,
  searchPlaceholder,
  onSearchChange,
  onOpenFilters,
  activeFiltersCount = 0
}) => {
  const { t } = useTranslation();

  return (
    <div className="list-toolbar">
      <Input
        className="list-toolbar__search"
        size="large"
        value={searchValue}
        placeholder={searchPlaceholder}
        aria-label={searchPlaceholder}
        suffix={<SearchOutlined />}
        allowClear
        onChange={(event) => onSearchChange(event.target.value)}
      />
      {onOpenFilters && (
        <Badge count={activeFiltersCount} size="small">
          <Button
            size="large"
            icon={<FilterOutlined />}
            aria-label={t('common.filters.all')}
            onClick={onOpenFilters}
          >
            <span className="list-toolbar__filters-label">
              {t('common.filters.all')}
            </span>
          </Button>
        </Badge>
      )}
    </div>
  );
};

export default ListToolbar;
